import React from 'react'
import PropTypes from 'prop-types'
import './ResultTable.css'
import DomainEntry from './DomainEntry'
import ResourceEntry from './ResourceEntry'

const ResultTable = (props) => {
	const rows = []
	const resourceSort = (a, b) => {
		const domainComp = a.Domain === b.Domain ? 0 : (a.Domain > b.Domain ? 1 : -1)
		const statusComp = a.Status === b.Status ? 0 : (a.Status > b.Status ? 1 : -1)
		const resourceComp = a.Resource === b.Resource ? 0 : (a.Resource > b.Resource ? 1 : -1)
		return domainComp || statusComp || resourceComp
	}

	const sortedResources = props.resources.slice().sort(resourceSort)
	const sortedDomains = props.domains.slice().sort()

	const domains = sortedResources.reduce((acc, value) => {
		if (acc.has(value.Domain)) {
			acc.get(value.Domain).ok = (acc.get(value.Domain).ok && (value.Status === 1))
		} else {
			acc.set(value.Domain, {
				name: value.Domain,
				resources: [],
				ok: true,
			})
		}
		acc.get(value.Domain).resources.push({
			name: value.Resource,
			url: value.URL,
			ok: (value.Status === 1),
      busy: value.Busy,
      error: value.Error
		})
		return acc
	}, new Map())

	sortedDomains.forEach((domain) => {
		if (!domains.has(domain)) {
			domains.set(domain, {
				name: domain,
				resources: [],
				ok: true,
			})
		}
	})

	domains.forEach((domain) => {
    rows.push(<DomainEntry key={domain.name} name={domain.name} statusOk={domain.ok}
                           editable={domain.name === props.editableDomain}
                           toggleDomainEdit={props.toggleDomainEdit}/>)
		domain.resources.forEach((resource) => {
			rows.push(<ResourceEntry key={domain.name + ":" + resource.name} name={resource.name}
                               editable={domain.name === props.editableDomain} busy={resource.busy}
                               statusOk={resource.ok} url={resource.url} error={resource.error}
                               delete={props.deleteDomainResource}/>)
		})
	})

	return (
		<div className="ResultTable">
			{rows}
		</div>
	)
}

ResultTable.propTypes = {
	domains: PropTypes.arrayOf(PropTypes.string).isRequired,
	resources: PropTypes.arrayOf(PropTypes.shape({
		Domain: PropTypes.string.isRequired,
    URL: PropTypes.string.isRequired,
		Resource: PropTypes.string.isRequired,
		Status: PropTypes.number.isRequired,
    Busy: PropTypes.bool,
    Error: PropTypes.bool,
	})),
	deleteDomainResource: PropTypes.func.isRequired,
  toggleDomainEdit: PropTypes.func.isRequired,
}

export default ResultTable


// WEBPACK FOOTER //
// ./src/components/ResultTable/ResultTable.js